import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function GetRiderNameDropdown(data) {
    return Networking.PostApi(ApiValues.getRiderName, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}
export default GetRiderNameDropdown;